import React from 'react'

import useResearcher from './useResearcher'
import useFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import { menuTab } from '../../../../../../constants/constants'
import TerminateProjectRequestForm from '../../../page/requestNewProject/terminateProject/terminateProject'
import ResultOfConsiderPrevious from '../../../page/resultOfConsiderPrevious/closeProject/resultOfConsiderPrevious'
import ResultOfConsider from '../../../page/resultOfConsider/terminateProject/resultOfConsider'

type ResearcherViewType = ResearcherType & ReturnType<typeof useResearcher>
const ResearcherView: React.FC<ResearcherViewType> = (props) => {
    const { initialData, isViewMode, submittedType, formValueRef, projectData, projectMode, callbackSaveComplete } =
        props
    const folderAndTabStore = useFolderAndTabStore()
    const renderPage = () => {
        switch (folderAndTabStore?.tabSelected?.id) {
            case menuTab.tab21.id:
            case menuTab.tab25.id:
                return (
                    <TerminateProjectRequestForm
                        formMode={projectMode}
                        projectSubmittedTypeID={submittedType}
                        initialData={initialData}
                        isViewMode={isViewMode}
                        btnClose={isViewMode}
                        formValueRef={formValueRef}
                        onSaveComplete={callbackSaveComplete}
                    />
                )
            case menuTab.tab23.id:
                return <ResultOfConsider projectData={projectData ?? undefined} />
            case menuTab.tab26.id:
                return (
                    <>
                        <ResultOfConsiderPrevious
                            projectID={projectData?.projectID ?? 0}
                            submittedID={projectData?.aroundSubmittedIDInfo.previousSubmittedID ?? 0}
                        />
                    </>
                )
            // return <div>ผลพิจารณาครั้งก่อน</div>
            default:
                return <></>
        }
    }
    return renderPage()
}

export type ResearcherType = {
    projectMode: 'CREATE' | 'EDIT'
    callbackSaveComplete?: (resStatus: number, isDraft: boolean) => void
}
const Researcher: React.FC<ResearcherType> = (props) => {
    const researcher = useResearcher(props)
    return <ResearcherView {...props} {...researcher} />
}
export default Researcher
